import { Entity, Nullable } from '@pinup-teams/common';

export interface AiChatFilters {
  limit: number;
  offset: number;
}

export interface Chat {
  id: string;
  chatTitle: string;
}

export interface ChatMessage extends Entity<string> {
  chatId: string;
  request: string;
  reply: string;
  createdAt: string;
  lang: 'ru' | 'en' | 'uk';
  links: Nullable<ChatLink[]>;
  internalStatus?: InternalMessageStatus;
  status?: ChatMessageStatus;
  isSuccessReply?: boolean;
  reactionType?: ChatMessageReaction;
  isFeedbackProvided?: boolean;
  ppSlackId?: string;
  ppFullName?: string;
  ppConfluencePage?: string;
  replyType: ChatMessageReplyTypes;
  timeOffBalances?: ChatMessageTimeOffBalance[];
  chatStarted?: string;
}

export interface ChatLink {
  label: string;
  url: string;
}

export interface ChatMessageFeedback {
  text: string;
  feedbackType: ChatMessageFeedbackReasons;
}

export interface ChatMessageTimeOffBalance {
  type: ChatMessageTimeOfTypes;
  value: number;
}

export enum ChatMessageReplyTypes {
  SIMPLE = 'SIMPLE',
  VACATION_BALANCE = 'VACATION_BALANCE',
  SICK_LEAVE_BALANCE = 'SICK_LEAVE_BALANCE',
  SICK_LEAVE_80_BALANCE = 'SICK_LEAVE_80_BALANCE',
  DAY_OFF_BALANCE = 'DAY_OFF_BALANCE',
  RECOVERY_BALANCE = 'RECOVERY_BALANCE',
  FAMILY_BALANCE = 'FAMILY_BALANCE',
  TOTAL_BALANCE = 'TOTAL_BALANCE',
  JIRA_TASK = 'JIRA_TASK',
  JIRA_READY_TO_CREATE = 'JIRA_READY_TO_CREATE',
}

export type ChatMessageTimeOfTypes = Exclude<
  ChatMessageReplyTypes,
  | ChatMessageReplyTypes.SIMPLE
  | ChatMessageReplyTypes.TOTAL_BALANCE
  | ChatMessageReplyTypes.JIRA_TASK
  | ChatMessageReplyTypes.JIRA_READY_TO_CREATE
>;

export enum ChatMessageFeedbackReasons {
  inappropriate = 'INAPPROPRIATE',
  wrong = 'WRONG',
  unacceptable = 'UNACCEPTABLE',
  other = 'OTHER',
}

export enum ChatMessageStatus {
  InProgress = 'IN_PROGRESS',
  Undelivered = 'UNDELIVERED',
  Delivered = 'DELIVERED',
  Error = 'ERROR',
}

export enum InternalMessageStatus {
  pending = 'pending',
  resolved = 'resolved',
  failed = 'failed',
  timeout = 'timeout',
}

export enum ChatMessageReaction {
  like = 'POSITIVE',
  dislike = 'NEGATIVE',
  none = null,
}

export interface GetUserChatsRes {
  chats: Chat[];
}

export interface GetMessagesReq {
  chatId: string;
  limit: number;
  offset: number;
}

export interface GetMessagesRes {
  messages: ChatMessage[];
  total: number;
}

export interface SendQuestionReq {
  chatId: string;
  messageId: string;
  request: string;
  chatStarted: string;
}

export type SendQuestionRes = ChatMessage;

export type LeaveFeedbackReq = Entity<string> & ChatMessageFeedback;

export interface ToggleReactionReq {
  id: string;
  reaction: ChatMessageReaction;
}
